
import AppInsightsProvider from "./appinsights-provider";
export default AppInsightsProvider;

export { useTrackPlayerEvent, useIsPlayerTracking, usePlayerAppInsights } from "./appinsights-hooks";
export type { IAppInsightsContext as IAIContext } from "./appinsights-types";